import { ApplicationFinancingType } from '../../constants/application-financing-type';
import { FinancingTypes } from '../../constants/financing-types';
import { Application, Dealer } from '../../gql/graphql';

export const getApplicationFinancingType = (application: Application | undefined, dealer: Dealer): ApplicationFinancingType => {
  // The application wins once it exists: it is stamped at draft creation and
  // immutable, whereas the dealer's configuration can change underneath it.
  //   if (application?.financingType) {
  //     return application.financingType === FinancingTypes.installment_loan ? FinancingType.installmentLoan : FinancingType.lease;
  //   }

  if (application?.installmentLoan) return ApplicationFinancingType.installmentLoan;
  if (application?.lease) return ApplicationFinancingType.lease;

  // Pre-application (entry, OTP, pre-qualification) there is no application to read.
  return dealer?.financingType === FinancingTypes.installment_loan ? ApplicationFinancingType.installmentLoan : ApplicationFinancingType.lease;
};
